function unixToLocalDate(timestamp) {
    try {
        const fecha = new Date(timestamp * 1000);
        const options = { month: 'long', day: 'numeric', year: 'numeric' };
        return fecha.toLocaleDateString('en-US', options);
    }
    catch (error) {
        return `${timestamp}`;
    }
}
function stringToInputValue(stringDate) {
    try {
        return new Date(stringDate).toISOString().substr(0, 10);
    }
    catch (error) {
        return null;
    }
}
export { unixToLocalDate, stringToInputValue };
